<div class="auth-page">
  <div class="auth-container">
    <!-- Left: Brand panel -->
    <div class="auth-panel">
      <a routerLink="/" class="auth-brand">
        <img src="logo-mark.svg" alt="Quick Indexing" class="brand-mark" />
        <span>Quick Indexing</span>
      </a>

      <div class="auth-pitch">
        <h1 class="pitch-title">Index smarter.<br/>Rank faster.</h1>
        <p class="pitch-text">
          The fastest URL indexing service for SEO professionals.
          Submit URLs, get them indexed in minutes, track everything in real-time.
        </p>

        <ul class="pitch-features">
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <span>98.5% success rate</span>
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <span>Average index time under 2 minutes</span>
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <span>REST API for developers</span>
          </li>
          <li>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <span>No subscriptions, pay per use</span>
          </li>
        </ul>
      </div>

      <div class="auth-stats">
        <div class="stat">
          <div class="stat-value">10M+</div>
          <div class="stat-label">URLs indexed</div>
        </div>
        <div class="stat">
          <div class="stat-value">5K+</div>
          <div class="stat-label">Active users</div>
        </div>
        <div class="stat">
          <div class="stat-value">99.9%</div>
          <div class="stat-label">Uptime</div>
        </div>
      </div>
    </div>

    <!-- Right: Auth form -->
    <div class="auth-form-panel">
      <div class="auth-form-inner">
        <!-- Tab switcher -->
        <div class="auth-tabs">
          <button class="auth-tab" [class.active]="!showRegister" (click)="showRegister = false">
            Sign in
          </button>
          <button class="auth-tab" [class.active]="showRegister" (click)="showRegister = true">
            Create account
          </button>
        </div>

        <!-- Sign in form -->
        <form #loginForm="ngForm" *ngIf="!showRegister" (ngSubmit)="loginForm.valid && login()" class="auth-form">
          <h2 class="auth-title">Welcome back</h2>
          <p class="auth-subtitle">Sign in to your Quick Indexing account</p>

          <div class="form-group">
            <label class="form-label">Username or Email</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="userIdOrEmail"
              name="userIdOrEmail"
              placeholder="you@example.com"
              required
              autocomplete="username"
              #userIdOrEmailInput="ngModel"
            />
            <div class="form-error" *ngIf="userIdOrEmailInput.invalid && (userIdOrEmailInput.dirty || userIdOrEmailInput.touched)">
              <span *ngIf="userIdOrEmailInput.errors?.['required']">Username or email is required</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-control"
              [(ngModel)]="password"
              name="password"
              placeholder="••••••••"
              required
              autocomplete="current-password"
              #passwordInput="ngModel"
            />
            <div class="form-error" *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)">
              <span *ngIf="passwordInput.errors?.['required']">Password is required</span>
            </div>
          </div>

          <div *ngIf="errorMessage" class="auth-error">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <span>{{ errorMessage }}</span>
          </div>

          <button type="submit" class="btn btn-primary auth-submit" [disabled]="isLoading || loginForm.invalid">
            <span class="spinner spinner-sm" *ngIf="isLoading"></span>
            <span>{{ isLoading ? 'Signing in...' : 'Sign in' }}</span>
          </button>

          <p class="auth-switch">
            Don't have an account?
            <button type="button" class="auth-link" (click)="showRegister = true; loginForm.resetForm()">Create one</button>
          </p>
        </form>

        <!-- Register form -->
        <form #registerForm="ngForm" *ngIf="showRegister" (ngSubmit)="registerForm.valid && register()" class="auth-form">
          <h2 class="auth-title">Create your account</h2>
          <p class="auth-subtitle">Get started with Quick Indexing in seconds</p>

          <div class="form-group">
            <label class="form-label">Username</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="registerData.userId"
              name="userId"
              placeholder="your_username"
              required
              minlength="3"
              #userIdInput="ngModel"
            />
            <div class="form-error" *ngIf="userIdInput.invalid && (userIdInput.dirty || userIdInput.touched)">
              <span *ngIf="userIdInput.errors?.['required']">Username is required</span>
              <span *ngIf="userIdInput.errors?.['minlength']">Username must be at least 3 characters</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Full name</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="registerData.fullName"
              name="fullName"
              placeholder="John Doe"
              required
              #fullNameInput="ngModel"
            />
            <div class="form-error" *ngIf="fullNameInput.invalid && (fullNameInput.dirty || fullNameInput.touched)">
              <span *ngIf="fullNameInput.errors?.['required']">Full name is required</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              [(ngModel)]="registerData.email"
              name="email"
              placeholder="you@example.com"
              required
              #emailInput="ngModel"
            />
            <div class="form-error" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
              <span *ngIf="emailInput.errors?.['required']">Email is required</span>
              <span *ngIf="emailInput.errors?.['email']">Please enter a valid email address</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Phone number</label>
            <div class="phone-input">
              <button type="button" class="country-code" (click)="showCountryDropdown = !showCountryDropdown">
                <span>{{ getSelectedCountry().flag }}</span>
                <span class="mono">{{ selectedCountryCode }}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              <div class="country-dropdown" *ngIf="showCountryDropdown">
                <div class="country-search">
                  <input type="text" placeholder="Search countries..." />
                </div>
                <div class="country-list">
                  <button type="button" class="country-item" *ngFor="let c of countryCodes" (click)="selectCountry(c.dial)">
                    <span>{{ c.flag }}</span>
                    <span class="country-name">{{ c.name }}</span>
                    <span class="country-dial mono">{{ c.dial }}</span>
                  </button>
                </div>
              </div>
              <input
                type="tel"
                class="form-control"
                [(ngModel)]="registerData.phoneNumber"
                name="phoneNumber"
                placeholder="98765 43210"
                required
                #phoneNumberInput="ngModel"
              />
            </div>
            <div class="form-error" *ngIf="phoneNumberInput.invalid && (phoneNumberInput.dirty || phoneNumberInput.touched)">
              <span *ngIf="phoneNumberInput.errors?.['required']">Phone number is required</span>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Password</label>
            <input
              type="password"
              class="form-control"
              [(ngModel)]="registerData.password"
              name="password"
              placeholder="••••••••"
              required
              minlength="8"
              #passwordInput="ngModel"
            />
            <div class="form-error" *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)">
              <span *ngIf="passwordInput.errors?.['required']">Password is required</span>
              <span *ngIf="passwordInput.errors?.['minlength']">Password must be at least 8 characters</span>
            </div>
          </div>

          <div *ngIf="errorMessage" class="auth-error">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <span>{{ errorMessage }}</span>
          </div>

          <button type="submit" class="btn btn-primary auth-submit" [disabled]="isRegistering || registerForm.invalid">
            <span class="spinner spinner-sm" *ngIf="isRegistering"></span>
            <span>{{ isRegistering ? 'Creating account...' : 'Create account' }}</span>
          </button>

          <p class="auth-switch">
            Already have an account?
            <button type="button" class="auth-link" (click)="showRegister = false; registerForm.resetForm()">Sign in</button>
          </p>
        </form>
      </div>
    </div>
  </div>
</div>
